<template>
    <div class="c-science-volunteer-modal">
        <div v-if="modalData.isVolunteer">
            <aha-modal id="phdScienceVolunteerModal" ref="phdScienceVolunteerModal" size="md" hide-footer hide-header centered lazy>

                <h2 v-if="modalData.title" v-html="modalData.title" class="mb-4"></h2>

                <b-btn-close @click="$root.$emit('bv::hide::modal', 'phdScienceVolunteerModal', $event.target)">×</b-btn-close>

                <div v-if="modalData.message" v-html="modalData.message"></div>

                <div class="d-flex justify-content-around mt-4">
                    <a v-if="modalData.yesRedirect" :href="modalData.yesRedirect" v-html="modalData.yesLabel" class="btn btn-round btn-primary"></a>
                    <button class="btn btn-round btn-dark" v-html="modalData.noLabel" @click="$root.$emit('bv::hide::modal', 'phdScienceVolunteerModal', $event.target)"></button>
                </div>
            </aha-modal>
        </div>
    </div>
</template>

<script>
    import Cookies from 'js-cookie';

    export default {
        data() {
            return {
                cookieString: 'hide-science-volunteer-modal'
            };
        },
        props: {
            modalData: {
                type: Object,
                required: true
            },
        },
        mounted() {
            let hideModalSessionCookie = Cookies.get(this.cookieString);

            if(this.modalData.isVolunteer && hideModalSessionCookie === undefined) {
                this.$refs.phdScienceVolunteerModal.show();
                Cookies.set(this.cookieString, true, {SameSite: 'Strict'});
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/app/components/phd/phd-science-volunteer-modal.vue